<template>
  <video ref="videoPlayer" class="video-js"></video>
</template>

<script src="./ctrl-videojs.js"></script>
